import { connect } from 'react-redux';
import FolderCreator from '../../components/FolderCreatorFromSelection';

export default connect()(FolderCreator);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/FolderCreatorFromSelection/index.ts